var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#ECFDF3",
    strokeWidth: 13.3333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6668 45.4666V46.9999C63.6648 50.594 62.501 54.0911 60.3491 56.9696C58.1971 59.8482 55.1723 61.9541 51.7258 62.9731C48.2792 63.9921 44.5956 63.8698 41.2243 62.6242C37.853 61.3787 34.9746 59.0768 33.0184 56.0617C31.0623 53.0467 30.1331 49.48 30.3696 45.8938C30.6061 42.3075 31.9955 38.8938 34.3306 36.1617C36.6658 33.4296 39.8215 31.5256 43.3271 30.7335C46.8328 29.9415 50.5006 30.3038 53.7835 31.7666M63.6668 33.6666L47.0002 50.3499L42.0002 45.3499",
    stroke: "#039855",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCompleted);
export default __webpack_public_path__ + "static/media/green_completed.48ea20ad4fac97f775c46331e3cbb7f4.svg";
export { ForwardRef as ReactComponent };